var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    attrs: {
      "background": "static/img/Heavy-Duty-Warehouse-Trucks-in-Miami.jpg"
    }
  }, [_c('section', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "app2 flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-9 col-sm-10 col-xs-10"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card text-white py-3 d-md-down-none",
    staticStyle: {
      "width": "44%",
      "background-color": "#119bd6c2 !important"
    }
  }, [_c('img', {
    staticClass: "dark-logo",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "src": "static/img/logo.png",
      "alt": "homepage",
      "width": "40%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6rem !important"
    }
  }, [_c('label', {
    staticClass: "login_title"
  }, [_vm._v(_vm._s(_vm.$t('loginPage.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-center"
  }, [_c('div', [_c('p', {
    staticClass: "xb_text"
  }, [_vm._v(_vm._s(_vm.$t('loginPage.description')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card py-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "model": _vm.form
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-6",
    staticStyle: {
      "margin-top": "8rem",
      "margin-bottom": "1rem",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "12.5rem"
    }
  }, [(!_vm.isAuthenticated) ? _c('button', {
    staticClass: "-btn btn-primary1 px-4",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]) : _vm._e()])])], 1)])])])])])])])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cbd43100", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbd43100","hasScoped":true}!./src/views/components/login/login.component.html
// module id = 875
// module chunks = 0